<template>
  <section v-if="content.body.length">
    <!-- <div class="mb-4" v-if="content.body && content.body.length > 0">
      <div class="headline" v-text="content.title"></div>
      <div
        class="subtitle-1 grey--text text--darken-2"
        v-text="content.subtitle"
      ></div>
    </div> -->
    <carousel-3d
      :style="{
        color: `${themeColor}`,
      }"
      :perspective="0"
      :width="640"
      :height="360"
      :autoplay="true"
      :autoplay-timeout="interval * 1000"
      :display="3"
      :controlsVisible="true"
      :space="360"
      v-if="content.body && content.body.length > 0"
    >
      <slide v-for="(item, i) of content.body" :index="i" :key="i">
        <a>
          <img @click="openBanner(item)" :src="item.image" alt />
        </a>
      </slide>
    </carousel-3d>
  </section>
</template>

<script>
import Vue from "vue";
import { VCardText } from "vuetify/lib";
import { Carousel3d, Slide } from "vue-carousel-3d";

export default {
  name: "banner_slider",
  props: ["content"],
  components: { VCardText, Carousel3d, Slide },
  computed: {
    itemLength() {
      return this.content.body.length;
    },
    themeColor() {
      return Vue.prototype.$userInfo.companies[0].themeColor;
    },
  },
  data: () => ({
    onboarding: 0,
    timerId: null,
    interval: 10,
    autoPlay: true,
  }),
  mounted() {
    if (this.autoPlay) {
      this.play();
    }
  },
  methods: {
    play() {
      //   console.log(this.onboarding);
      this.timerId = setTimeout(() => {
        let idx = this.onboarding + 1;
        if (idx > this.itemLength - 1) {
          this.onboarding = 0;
        } else {
          this.onboarding = idx;
        }
        this.$nextTick(() => {
          this.play();
        });
      }, this.interval * 1000);
    },
    stop() {
      if (this.timerId != null) {
        clearTimeout(this.timerId);
      }
    },
    onChange() {
      //   console.log("change by user");
      if (this.autoPlay) {
        this.stop();
        this.play();
      }
    },
    navigate(item) {
      console.log("navigate");

      if (item.url != null) {
        this.$router.push(item.url);
      }
    },
    openBanner(item) {
      if (item.url) {
        window.open(item.url, "_blank");
      }
    },
  },
};
</script>